import Styles from 'react-select';

export const MultiselectCustomStyles: Partial<Styles> = {
  control: (provided: any, state: any) => ({
    ...provided,
    borderColor: state.isFocused ? '#34a06b' : '#e2e2e2',
    padding: '0 2rem',
    boxShadow: state.isFocused ? '0 0 0 0 #34a06b' : 'none',
    '&:hover': {
      borderColor: state.isFocused ? '#34a06b' : '#e2e2e2',
    },
    width: '100%',
    minHeight: '4.8rem',
    '@media screen and (min-width: 1024px)': {
      ...provided['@media screen and (min-width: 1024px)'],
      width: '41.2rem',
    },
    '@media screen and (min-width: 1420px)': {
      ...provided['@media screen and (min-width: 1024px)'],
      width: '50rem',
    },
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    padding: '0 6px',
  }),
  input: (provided: any) => ({
    ...provided,
    paddingTop: '0px',
    paddingBottom: '0px',
    margin: '0px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  indicatorsContainer: (provided: any) => ({
    ...provided,
    height: '4.8rem',
  }),
  menu: (provided: any) => ({
    ...provided,
    width: '100%',
    '@media screen and (min-width: 1024px)': {
      ...provided['@media screen and (min-width: 1024px)'],
      width: '41.2rem',
    },
    '@media screen and (min-width: 1420px)': {
      ...provided['@media screen and (min-width: 1024px)'],
      width: '50rem',
    },
    zIndex: 3,
  }),
  menuList: (provided: any) => ({
    ...provided,
    width: '100%',
    '@media screen and (min-width: 1024px)': {
      ...provided['@media screen and (min-width: 1024px)'],
      width: '41.2rem',
    },
    '@media screen and (min-width: 1420px)': {
      ...provided['@media screen and (min-width: 1024px)'],
      width: '50rem',
    },
  }),
};
